import React, { useState, useEffect, useMemo } from 'react';
import { View } from 'react-native'

import tw from '../../../../../styles/tailwind';
import Text from '../../../../../components/Text';
import Icon from '../../../../../components/IcomoonIcon';
import { useController, useForm, useWatch } from 'react-hook-form';
import DateSelector from '../../../../../components/Forms/DateSelector';
import dayjs from 'dayjs';
import { FooterButtons, TabsSelector } from '../NewGuestPassModal';



export default function PassTimeStep({
  control,
  setValue,
  name,
  onNextPressed,
  onBackPressed,
  isLastStep=false,
  isSubmitting=false,
}) {
  // const { field, fieldState: { invalid, isTouched, isDirty, error }, formState } = useController({
  //   control,
  //   name,
  // })

  const entry_time = useWatch({
    control,
    name: "entry_time",
  })

  const [lastEntryTime, setLastEntryTime] = useState(entry_time);

  // console.log("passtimestep", { entry_time, formState :null });
  

  const entryTimeStr = entry_time && entry_time !== 'all_day' ? entry_time.toTimeString?.()?.substr(0, 5) : ""

  // ! mover a effect?
  const [time, setTime] = useState((entry_time == 'all_day') ? entry_time : 'time_range');


  const entry_time_limit = useWatch({
    control,
    name: "entry_time_limit",
  })

  const entryTimeLimitStr = entry_time_limit ? entry_time_limit.toTimeString?.()?.substr(0, 5) : ""


  useEffect(() => {
    if (time === 'time_range' && entry_time == 'all_day') {
      const newDate = dayjs().startOf('hour')
      const newDateLimit = newDate.add(3, 'hour')

      setValue('entry_time', newDate.toDate())
      setValue('entry_time_limit', newDateLimit.toDate())
    }
  }, [time]);

  useEffect(() => {
    if (entry_time !== 'all_day' && entry_time != lastEntryTime){
      const entryTime = dayjs(entry_time)
      const entryTimeLimit = entryTime.add(3, 'hour')

      //! Por alguna razón al darle setValue('entry_time_limit', entryTimeLimit.toDate())
      //! Como que el objeto entry_time se regenera entonces entra en un loop infinito de este efecto
      //! y por lo mismo la validación entry_time != lastEntryTime también siempre es true
      if (entry_time.toISOString() != lastEntryTime.toISOString?.()){
        setValue('entry_time_limit', entryTimeLimit.toDate())
        setLastEntryTime(entry_time)
      }
    }
  }, [entry_time]);

  return (
    <>
      <View style={tw`flex-1`}>
        <Text style={tw`text-white text-center text-xl font-500 mb-8`}>¿A que hora llega tu visita?</Text>

        <TabsSelector
          onChange={(time) => {
            setTime(time)
            setValue('entry_time', 'all_day')
            setValue('entry_time_limit', null)

          }}
          values={[
            { key: 'all_day', title: 'Todo el día' },
            { key: 'time_range', title: 'Horario' },
          ]}
          initialValue={time}
        />

        <View style={tw`px-10 mt-8 mb-8`}>
          {
            time === 'all_day' ?
              <Text style={tw`text-white text-center text-xl`}>Tu visita tendrá acceso en todo momento</Text>
              :
              <Text style={tw`text-white text-center text-xl`}>Elige un horario en el que tu visita podrá acceder</Text>
          }
        </View>

        {/* Rango de horas */}
        {
          time === 'time_range' &&
          <View style={tw``}>
            <View style={tw`gap-y-4 bg-primary-100 rounded-2xl px-4 py-4`}>
              {/* Selector Desde */}
              <View style={tw`row justify-between bg-white rounded-xl border border-primary-300 pl-6 pr-4 py-4`}>
                <Text style={tw`text-gray-600 font-500`}>Desde</Text>

                <View style={tw`row`}>
                  <Text style={tw`text-gray-600 font-500 text-lg mr-2 text-secondary`}>{entryTimeStr}</Text>

                  <Icon name='chevron-right' size={12} style={tw`-mt-1`} color={tw.color('secondary')} />
                </View>

                {/* Input oculto */}
                <View style={tw`mb-0 absolute left-0 right-0 top-0 bottom-0 z-100`}>
                  <DateSelector style={tw`mb-0 opacity-2 h-100%`} control={control} mode='time' name="entry_time" minuteInterval={15} rules={{ required: true }} />
                </View>
              </View>


              {/* Selector Hasta */}
              <View style={tw`row justify-between bg-white rounded-xl border border-primary-300 pl-6 pr-4 py-4`}>
                <Text style={tw`text-gray-600 font-500`}>Hasta</Text>

                <View style={tw`row`}>
                  <Text style={tw`text-gray-600 font-500 text-lg mr-2 text-secondary`}>{entryTimeLimitStr}</Text>

                  <Icon name='chevron-right' size={12} style={tw`-mt-1`} color={tw.color('secondary')} />
                </View>

                {/* Input oculto */}
                <View style={tw`mb-0 absolute left-0 right-0 top-0 bottom-0 z-100`}>
                  <DateSelector style={tw`mb-0 h-100% opacity-2`} control={control} mode='time' name="entry_time_limit" minuteInterval={15} rules={{ required: true }} />
                </View>
              </View>
            </View>
          </View>
        }
      </View>

      <FooterButtons
        onBackPressed={onBackPressed}
        onNextPressed={onNextPressed}
        lastStep={isLastStep}
        isSubmitting={isSubmitting}
        // nextDisabled={!field.value}
      />
    </>
  )
}